import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { store } from '../../store'
import configuration from '../../configuration.js'
import * as UI from '../../lib/ui'
import {
  getUrlSearchParameter,
  triggerSentryError,
} from '../../../../shared/helpers'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'
import Platform from '../../platforms/index.js'
import { ERROR_STATUS } from '../../screens/ErrorScreen/types'

class Deeplink extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.trydeeplink = this.trydeeplink.bind(this)
  }

  trydeeplink() {
    try {
      this.deeplink()
    } catch (error) {
      triggerSentryError('Tizen - Could not Deeplink', 'Deeplink.js', {
        errorMessage: error.message ?? 'Undefined error message (default)',
      })
    }
  }

  componentDidMount() {
    window.addEventListener('appcontrol', this.trydeeplink)
    if (COMPILING_FOR_TIZEN) {
      this.trydeeplink()
    } else if (COMPILING_FOR_VIZIO) {
      try {
        const windowUrl = window.location.href
        this.vizioDeeplink(windowUrl)
        // let getContentTypeFromUrl

        window.VIZIO.setContentChangeHandler((incomingUrl) => {
          this.vizioDeeplink(incomingUrl)

          /* getContentTypeFromUrl = incomingUrl.includes('type=show')
            ? 'Show'
            : 'Video'

          // Deeplink event VIZIO
          window.ga('send', {
            hitType: 'event',
            eventCategory: 'Deep Link',
            eventAction: `${getContentTypeFromUrl}`,
            eventLabel: `${incomingUrl.split('?')[1]}`,
          }) */
        })
      } catch (e) {
        triggerSentryError('VIZIO - Could not Deeplink', 'Deeplink.js', {
          errorMessage: e.message ?? 'Undefined error message (default)',
        })
        window.location.href = '/'
      }
    } else if (COMPILING_FOR_LGTV) {
      Platform.deeplink(this.setAndMaybeGo.bind(this))
    } else if (COMPILING_FOR_COMCASTX1) {
      this.comcastDeeplink()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('appcontrol', this.trydeeplink)
  }

  vizioDeeplink = (url) => {
    const videoStringParse =
      url.includes('type=video') &&
      url
        .split('&')
        .find((x) => x.includes('contentid='))
        .split('=')[1]
    const showStringParse =
      url.includes('type=show') &&
      url
        .split('&')
        .find((x) => x.includes('contentid='))
        .split('=')[1]

    // If any query param starts with utm_ it means the deeplink has campaign information
    // Check if campaign data is present and sent it for analitycs
    /* if (url.includes('utm_')) {
      const campaignParamKeys = Object.entries(
        configuration.analyticsCampaignParams
      )
      campaignParamKeys.forEach((param) => {
        const paramValue = getUrlSearchParameter(url, param[0])
        if (paramValue) {
          window.ga('set', param[1], paramValue)
        }
      })
    } */

    if (videoStringParse) {
      UI.setSidePanelVisibility(false)
      let to = configuration.deeplinkPatterns['video'].replace(
        '{{videoId}}',
        videoStringParse
      )
      // if autoplay flag is true we want to go to /video-playback instead of /video-details
      if (url.includes('autoplay=true')) {
        to = to.replace('video-details', 'video-playback')
      }
      /* window.ga('send', {
        hitType: 'event',
        eventCategory: 'Deep Link',
        eventAction: 'Video',
        eventLabel: `${url.split('?')[1]}`,
      }) */
      this.setAndMaybeGo(to)
    } else if (showStringParse) {
      UI.setSidePanelVisibility(false)
      const to = configuration.deeplinkPatterns['show'].replace(
        '{{seriesId}}',
        showStringParse
      )

      /* window.ga('send', {
        hitType: 'event',
        eventCategory: 'Deep Link',
        eventAction: 'Show',
        eventLabel: `${url.split('?')[1]}`,
      }) */
      this.setAndMaybeGo(to)
    }
  }

  comcastDeeplink() {
    import('@firebolt-js/sdk').then(async (firebolt) => {
      const Discovery = firebolt.Discovery
      const Parameters = firebolt.Parameters
      const deepLink = location.href

      const handleIntent = (intent = {}) => {
        const { action, data = {} } = intent
        const { entityId, assetId } = data
        let url

        if (deepLink.includes('utm_')) {
          // needs confirmation
          const campaignParamKeys = Object.entries(
            configuration.analyticsCampaignParams
          )
          campaignParamKeys.forEach((param) => {
            const paramValue = getUrlSearchParameter(deepLink, param[0])
            if (paramValue) {
              // window.ga('set', param[1], paramValue)
            }
          })
        }

        if (action === 'entity') {
          // "launchpoint=detail" from IBIS turns into "entity" in firebolt
          if (!assetId) {
            // if there is no assetId it is a show
            url = configuration.deeplinkPatterns['show'].replace(
              '{{seriesId}}',
              entityId
            )
          } else if (assetId) {
            // if there is assetId it is a video
            url = configuration.deeplinkPatterns['video'].replace(
              '{{videoId}}',
              assetId
            )
          }
        } else if (action === 'playback') {
          url = configuration.deeplinkPatterns['video'].replace(
            '{{videoId}}',
            assetId
          )
          url = url.replace('video-details', 'video-playback')
        }

        if (url) {
          UI.setSidePanelVisibility(false)
          /* window.ga('send', {
            hitType: 'event',
            eventCategory: 'Deep Link',
            eventAction: (!assetId && 'Show') || (assetId && 'Video') || '',
            eventLabel: location.href,
          }) */
          this.setAndMaybeGo(url)
        }
      }

      // DeepLinking from cold app
      Parameters.initialization().then(({ discovery = {} }) => {
        const { navigateTo: intent = {} } = discovery
        handleIntent(intent)
      })

      // DeepLinking from running app
      Discovery.listen(Discovery.Events.NAVIGATE_TO, (intent) => {
        handleIntent(intent)
      })
    })
  }

  deeplink = (e) => {
    let hasDeeplink = false
    let appControlData
    let actionData

    let videoId = ''
    let seriesId = ''
    let type = ''

    if (COMPILING_FOR_TIZEN) {
      const requestedAppControl = window.tizen.application
        .getCurrentApplication()
        .getRequestedAppControl()

      if (requestedAppControl) {
        appControlData = requestedAppControl.appControl.data // get appcontrol data. action_data (needed for eden json) is in it.

        for (let i = 0; i < appControlData.length; i++) {
          // find PAYLOAD property.
          if (appControlData[i].key === 'PAYLOAD') {
            // Get action_data (deeplink payload data) parse once to get values
            try {
              actionData = JSON.parse(
                JSON.parse(appControlData[i].value[0]).values
              )
            } catch (error) {
              triggerSentryError(
                'Could not parse actionData 1',
                'Deeplink.js',
                {
                  errorMessage:
                    error.message ?? 'Undefined error message (default)',
                }
              )
              return
            }
          }
        }
      }
    } else if (e) {
      if (e.actionData) {
        try {
          actionData = JSON.parse(e.actionData)
        } catch (error) {
          triggerSentryError('Could not parse actionData 2', 'Deeplink.js', {
            errorMessage: error.message ?? 'Undefined error message (default)',
          })
          return
        }
      }
    }

    if (actionData) {
      type = actionData.type

      if (type) {
        for (var key in actionData) {
          if ('type' === key) {
            type = actionData[key]
          } else if ('videoIdx' === key) {
            videoId = actionData[key]
          } else if ('seriesIdx' === key) {
            seriesId = actionData[key]
          }
          hasDeeplink = true
        }
      } else if (actionData.assetId) {
        type = 'search'
        videoId = actionData.assetId
        hasDeeplink = true
      }
    }

    if (hasDeeplink) {
      let deeplink = ''

      if (('video' === type || 'search' === type) && '' !== videoId) {
        deeplink = configuration.deeplinkPatterns['video'].replace(
          '{{videoId}}',
          videoId
        )
      } else if ('show' === type && '' !== seriesId) {
        deeplink = configuration.deeplinkPatterns['show'].replace(
          '{{seriesId}}',
          seriesId
        )
      }

      /* let getContentTypeFromUrl = deeplink.includes('show-details')
        ? 'Show'
        : 'Video' */

      /* for (const subKey in actionData) {
        if (subKey.includes('utm_')) {
          try {
            window.ga(
              'set',
              configuration.analyticsCampaignParams[subKey],
              actionData[subKey]
            )
          } catch (_) {
            triggerSentryError(
              'Could not set campaign data in Deeplink.js',
              subKey
            )
          }
        }
      } */
      // Deeplink event Tizen
      /* window.ga('send', {
        hitType: 'event',
        eventCategory: 'Deep Link',
        eventAction: `${getContentTypeFromUrl}`,
        eventLabel: `${deeplink}`,
      }) */
      this.setAndMaybeGo(deeplink)
    }
  }

  setAndMaybeGo(inputUrl) {
    if (inputUrl === this.props.router.location.pathname) {
      return
    }
    if (this.props.errorStatus === ERROR_STATUS.LOCALIZATION_ERROR) {
      this.props.router.navigate(inputUrl)
      return
    }

    if (this.props.sawSplash) {
      store.dispatch({
        type: 'DEEPLINK_URL',
        payload: {
          url: '',
          message: `Process deeplink ${inputUrl}`,
          deeplinkedTo: inputUrl,
        },
      })
      if (!this.props.station.station_id) {
        inputUrl = `/activate?redirect=${encodeURIComponent(inputUrl)}`
      }

      this.props.router.navigate(inputUrl)
    } else {
      store.dispatch({
        type: 'DEEPLINK_URL',
        payload: {
          url: inputUrl,
          message: `Process deeplink ${inputUrl}`,
          deeplinkedTo: inputUrl,
        },
      })
    }
  }

  render() {
    const { enabled, message, sawSplash, url } = this.props
    if (enabled) {
      const divStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 20,
        zIndex: 999,
      }

      return (
        <div style={divStyle}>
          <h1>Deeplink Message: {message}</h1>
          <h1>URL: {url}</h1>
          <h1>Saw Splash: {sawSplash.toString()}</h1>
        </div>
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = (state) => {
  return {
    station: state.station,
    message: state.deeplink.message,
    url: state.deeplink.url,
    sawSplash: state.deeplink.sawSplash,
    enabled: state.overlay.enabled,
    error: state.error.status,
    localize_station_step: state.station.localize_station_step,
  }
}

Deeplink.propTypes = {
  router: PropTypes.shape({
    navigate: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }),
  station: PropTypes.shape({
    station_id: PropTypes.string,
    localize_station_step: PropTypes.number,
  }),
  enabled: PropTypes.bool,
  message: PropTypes.string,
  url: PropTypes.string,
  sawSplash: PropTypes.bool,
  errorStatus: PropTypes.bool,
}

export default compose(
  withRouter(connect(mapStateToProps, null, null)(Deeplink))
)
